export class nodiUscentiIponimiaService {
nodiUscentiIponimia(event) {
    console.log("funzione nodi Uscenti Iponimia");
    
      let nodoDBClick = event.target;
      let nodoDBoutgoers = event.target.outgoers();
      var nodoDBOutgoersSuccessors =  nodoDBoutgoers.targets().successors().targets();
      var nodoDBOutgoersPredecessors = nodoDBoutgoers.targets().predecessors().sources();
  
      var edgePredecessors = nodoDBoutgoers.predecessors();
      var edgeSuccessors = nodoDBoutgoers.successors();
      nodoDBoutgoers.style("display", "element");
    
      // istruzioni per colorare nodi e archi di secondo livello in grigio
    
      // outgoers classe iponimia
      nodoDBOutgoersSuccessors.removeClass("iponimia");
      nodoDBOutgoersPredecessors.removeClass("iponimia");
      nodoDBOutgoersSuccessors.removeClass("iponimiaDBClick");
      nodoDBOutgoersPredecessors.removeClass("iponimiaDBClick");
    
      edgeSuccessors.removeClass("edges");
      edgePredecessors.removeClass("edges");
    
      // outgoers classe meronimia
      nodoDBOutgoersSuccessors.removeClass("meronimia");
      nodoDBOutgoersPredecessors.removeClass("meronimia");
      nodoDBOutgoersSuccessors.removeClass("meronimiaDBClick");
      nodoDBOutgoersPredecessors.removeClass("meronimiaDBClick");
    
      // outgoers classe sinonimia
      nodoDBOutgoersSuccessors.removeClass("sinonimia");
      nodoDBOutgoersPredecessors.removeClass("sinonimia");
      nodoDBOutgoersSuccessors.removeClass("sinonimiaDBClick");
      nodoDBOutgoersPredecessors.removeClass("sinonimiaDBClick");
    
      // se nodi sono tra 20 e 200
      if (nodoDBoutgoers.targets().toArray().length > 20 && nodoDBoutgoers.targets().toArray().length < 200) {
        // layout iponimi
        var iponimiOutgoers = event.target.outgoers('edge[relationType = "hyponym"]').targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 50, y1: nodoDBClick.position("y") - 150,
            h: 50, w: 50
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
        });
        iponimiOutgoers.run();
    
        if (nodoDBOutgoersSuccessors.toArray().length > 20 || nodoDBOutgoersPredecessors.toArray().length > 20) {
          // nodes
          nodoDBOutgoersSuccessors.addClass("2livello");
          nodoDBoutgoers.targets().predecessors().sources().addClass("2livello");
    
          // edges
          edgeSuccessors.addClass("2livello");
          edgePredecessors.addClass("2livello");
    
          nodoDBClick.removeClass("2livello");
          nodoDBoutgoers.targets().removeClass("2livello");
          nodoDBoutgoers.removeClass("2livello");
        }
    
      } else if (nodoDBoutgoers.targets().toArray().length > 200) {
        // layout iponimi
        var iponimiOutgoers = event.target.outgoers('edge[relationType = "hyponym"]').targets().layout({
          name: "grid", fit: true, boundingBox: {
            x1: nodoDBClick.position('x') - 45, y1: nodoDBClick.position("y") - 200,
            h: 200, w: 100
          }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
        });
        iponimiOutgoers.run();
    
        if (nodoDBoutgoers.targets().outgoers().targets().toArray().length > 20 || nodoDBoutgoers.targets().incomers().sources().toArray().length > 20) {
          // nodes
          nodoDBOutgoersSuccessors.addClass("2livello");
          nodoDBOutgoersPredecessors.addClass("2livello");
          // edges
          edgeSuccessors.addClass("2livello");
          edgePredecessors.addClass("2livello");
    
          nodoDBClick.removeClass("2livello");
          nodoDBoutgoers.targets().removeClass("2livello");
          nodoDBoutgoers.removeClass("2livello");
        }
        // posizionamento nodi nel caso di quantità inferiore a 20
      } else {
    
        nodoDBClick.removeClass("2livello");
        nodoDBoutgoers.targets().removeClass("2livello");
        nodoDBoutgoers.removeClass("2livello");
    
        // posizioni nodo cliccato, nodi entranti, nodi uscenti DA RIVEDERE
    
        nodoDBoutgoers.positions(function (nodi, i) {
          var xc = nodoDBClick.position('x');
          var yc = nodoDBClick.position('y');
          var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
          var yRet = yc - 75;
          return {
            x: xRet,
            y: yRet
          };
        });
      }
    
      return true
    }
}